<template>
  <div class="focused-panel">
    <div class="d-flex polytron-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create polygon" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select polygon" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete poly" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers" variant="primary">
        <icon scale=".6" name="link" />
      </b-btn>
    </div>

    <b-modal v-model="showForm" no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header">
        <label>Polygon ID: {{wellAttrs['id']}}</label>
      </div>
      <div class="p-2">
        <b-form>
          <b-row>
            <b-col>
              <b-form-group label="Type:" label-for="electric_type">
                <b-form-input id="electric_type"
                              v-model="wellAttrs['type']"
                              required
                              placeholder="Edit Type"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div slot="modal-footer" class="designatron-modal-footer">
        <b-row>
          <b-col>
            <div role="group" class="btn-group">
              <b-btn size="sm" class="float-right" variant="primary" @click="close">
                Close
              </b-btn>
              <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
                Save
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import 'vue-awesome/icons/arrows-alt'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/save'
  import 'vue-awesome/icons/check'
  import Vue from 'vue'

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import uuidV1 from 'uuid/v1'

  export default {
    name: 'electric',
    components: {

    },
    mixins: [FeatureEditorMixin],
    data () {
      return {
        markLastModified: false,
        featureId: null,
        addPolyEnabled: false,
        addLineEnabled: false,
        addPointEnabled: false,
        wellAttrs: {
          id: null,
          type: ''
        },
        options: [],
        causes: [],
        wellLayerName: 'v4:electric_zones',
        geomType: 'Polygon'
      }
    },
    methods: {
      editProps (feature) {
        this.featureId = feature.get('id')
        FeatureEditorMixin.methods.editProps.call(this, feature)
      },
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      }
    },
    watch: {
      currentEditor (val) {
        if (val !== this.editorIdent) {
          this.addEnabled = false
          this.selectEnabled = false
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },

      measureTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },
      infoTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },
      selectTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      }
    },
    computed: {
      selectTool () {
        return this.selectEnabled
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/ElectricEditor.vue